import { makeStyles } from "@material-ui/core";
import { Grid, Button, Typography } from "@material-ui/core";
import { history } from "../../../../../helpers";
import { routePaths } from "../../../../config/route-paths";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { quickPayService } from "../model/quickpay-services";
import { Skeleton } from "@material-ui/lab";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  quickPayButton: {
    "&:hover": {
      backgroundColor: theme.palette.ePrimary.hover,
    },
    borderRadius: 29,
    minWidth: "25%",
    backgroundColor: theme.palette.ePrimary.base,
    color: theme.palette.eWhite.base,
    fontSize:"0.75rem",
    margin:"8% auto"
  },
  quickPayHeading: {
    color: theme.palette.eRich.base,
  },

  skeleton: {
    background: theme.palette.eBackground.base
  },
 
}));
export default function EQuickPay() {
  const classes = useStyles();
  let quickPayRoute = (e) => {
    history.push(routePaths.QUICK_PAY);
  };
  const languageCode = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
  );
  const {t:quickPayLabel, ready: labelReady} = useTranslation(
    "label-E_AUTH_QUICK_PAY"
  );

  return (
    <>
      {labelReady ? (
        <Grid container>

          <Grid item>
            <Button
              variant="contained"
              className={[classes.quickPayButton].join(" ")}
              onClick={quickPayRoute}
            >
              {quickPayLabel("E_AUTH_QUICK_PAY_BUTTON")}
            </Button>
          </Grid>
        </Grid>
      ) : (
        <Skeleton variant="rect" animation="pulse" height="45px"/>
      )}
    </>
  );
}
